import { StyleSheet, css } from 'aphrodite';
import { images } from '../../constants';

const FindUs = () => (
  <section className={css(styles.wrapper)} id="contact">
    <div className={css(styles.imageContainer)}>
      <img src={images.gallery8} alt="The atmosphere at Fortress Restaurant" className={css(styles.image)} loading="lazy" />
    </div>

    <div className={css(styles.info)}>
      <p className={css(styles.eyebrow)}>Come hungry</p>
      <h2 className={css(styles.title)}>Your table is<br /><em>waiting.</em></h2>
      <p className={css(styles.address)}>
        Central Square, Shop 103<br />
        194 Bancor Avenue, Menlyn Maine<br />
        Pretoria East, 0181
      </p>

      <div className={css(styles.hoursGrid)}>
        <div><span>Monday - Saturday</span><strong>11:00 - 22:00</strong></div>
        <div><span>Sunday</span><strong>11:00 - 20:00</strong></div>
      </div>

      <div className={css(styles.actions)}>
        <a href="https://maps.app.goo.gl/baNFyQ5wPUisrCMv7" target="_blank" rel="noreferrer" className={css(styles.primary)}>Get directions ↗</a>
        <a href="tel:0127860145" className={css(styles.phone)}>012 786 0145</a>
      </div>
    </div>
  </section>
);

const styles = StyleSheet.create({
  wrapper: { display: 'grid', gridTemplateColumns: '1.05fr .95fr', minHeight: '720px', background: 'var(--color-cream)', '@media (max-width:900px)': { gridTemplateColumns: '1fr' } },
  imageContainer: { minHeight: '620px', overflow: 'hidden', margin: 'clamp(1.2rem,3vw,2.5rem)', borderRadius: '20px', '@media (max-width:900px)': { minHeight: '460px', marginBottom: 0 }, '@media (max-width:550px)': { minHeight: '360px' } },
  image: { width: '100%', height: '100%', objectFit: 'cover' },
  info: { display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-start', padding: 'clamp(4rem,8vw,8rem) clamp(1.5rem,6vw,6rem)' },
  eyebrow: { fontFamily: 'var(--font-ui)', color: 'var(--color-golden)', fontSize: '.72rem', fontWeight: 700, letterSpacing: '.18em', textTransform: 'uppercase', marginBottom: '1.2rem' },
  title: { fontFamily: 'var(--font-base)', color: 'var(--color-green)', fontSize: 'clamp(3rem,5vw,5.2rem)', lineHeight: 1.03, fontWeight: 500, letterSpacing: '-.035em' },
  address: { color: 'var(--color-gray)', fontSize: '.96rem', lineHeight: 1.8, margin: '2rem 0' },
  hoursGrid: { width: '100%', borderTop: '1px solid rgba(35,79,64,.16)', borderBottom: '1px solid rgba(35,79,64,.16)', '> div': { display: 'flex', justifyContent: 'space-between', gap: '1rem', padding: '1rem 0', fontFamily: 'var(--font-ui)', fontSize: '.74rem', textTransform: 'uppercase', letterSpacing: '.07em' }, '> div + div': { borderTop: '1px solid rgba(35,79,64,.1)' }, '> div > span': { color: 'var(--color-gray)' }, '> div > strong': { color: 'var(--color-green)' } },
  actions: { display: 'flex', alignItems: 'center', gap: '1.3rem', flexWrap: 'wrap', marginTop: '2rem' },
  primary: { padding: '1rem 1.3rem', borderRadius: '999px', background: 'var(--color-green)', color: 'var(--color-white)', fontFamily: 'var(--font-ui)', fontSize: '.7rem', fontWeight: 700, letterSpacing: '.1em', textTransform: 'uppercase' },
  phone: { color: 'var(--color-green)', fontFamily: 'var(--font-ui)', fontWeight: 700, fontSize: '.78rem', letterSpacing: '.06em', borderBottom: '1px solid rgba(35,79,64,.3)', paddingBottom: '.25rem' },
});

export default FindUs;
